/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerGetSegmentsFaceRecognitionsByDateQueryResponse, PntAppControllerGetSegmentsFaceRecognitionsByDatePathParams, PntAppControllerGetSegmentsFaceRecognitionsByDateQueryParams } from "../models/PntAppControllerGetSegmentsFaceRecognitionsByDate";

export function getPntAppControllerGetSegmentsFaceRecognitionsByDateUrl(slug: PntAppControllerGetSegmentsFaceRecognitionsByDatePathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/facerecognition` as const }
  return res
}

/**
 * @summary Retrieve the face recognitions for a given time range
 * {@link /pnt/v2/segments/:slug/facerecognition}
 */
export async function pntAppControllerGetSegmentsFaceRecognitionsByDate(slug: PntAppControllerGetSegmentsFaceRecognitionsByDatePathParams["slug"], params: PntAppControllerGetSegmentsFaceRecognitionsByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntAppControllerGetSegmentsFaceRecognitionsByDateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntAppControllerGetSegmentsFaceRecognitionsByDateUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}